var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.product
    ? _c("div", { staticClass: "pdp-display" }, [
        _c("div", { staticClass: "pdp-display__wrapper wrapper" }, [
          _c(
            "div",
            { staticClass: "pdp-display__gallery" },
            [
              _c(
                "product-gallery",
                _vm._b(
                  {},
                  "product-gallery",
                  {
                    product: _vm.product,
                    variant: _vm.variant,
                    enableBuyInStore: _vm.enableBuyInStore,
                    enableBuyOnline: _vm.enableBuyOnline
                  },
                  false
                )
              )
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "pdp-display__form" },
            [
              _c(
                "product-form",
                _vm._b(
                  { on: { variantChange: _vm.onVariantChange } },
                  "product-form",
                  {
                    product: _vm.product,
                    nutritionalDisclaimer: _vm.nutritionalDisclaimer,
                    shippingText: _vm.shippingText,
                    nutritionFactsVisible: _vm.nutritionFactsVisible
                  },
                  false
                )
              ),
              _c(
                "product-buy-in-store",
                _vm._b(
                  { attrs: { if: "enableBuyInStore" } },
                  "product-buy-in-store",
                  {
                    product: _vm.product,
                    variant: _vm.variant,
                    zipModalHeading: _vm.zipModalHeading,
                    zipModalBody: _vm.zipModalBody
                  },
                  false
                )
              )
            ],
            1
          )
        ])
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }